import React, { useState, useEffect } from 'react';
import { Navbar, Nav, NavDropdown, NavLink } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MainNavbarMenu.css';
import logo from '../../assets/logo.svg';
import { FaMapMarkerAlt, FaPhone, FaLanguage, FaCode, FaShoppingCart } from 'react-icons/fa'; // Importing icons
import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';




function MainNavbarMenu() {

  const [isSticky, setIsSticky] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const { i18n, t } = useTranslation();
  const [checked, setChecked] = useState(i18n.language === 'rs');
  const [searchQuery, setSearchQuery] = useState(''); // Added state for search input

  const handleChange = (nextChecked) => {
    setChecked(nextChecked);
    const newLang = nextChecked ? 'rs' : 'en';
    i18n.changeLanguage(newLang);
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 100) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleDropdownClose = () => {
    setExpanded(false);

  };

  // Fixed the search function to redirect to AG website
  const redirectToAG = () => {
    if (searchQuery.trim()) {
      const encoded = encodeURIComponent(searchQuery);
      // Using the simpler search URL format that should work without cHash issues
      const searchUrl = `https://www.hansa-flex.de/en/search/?tx_indexedsearch_pi2[action]=search&tx_indexedsearch_pi2[controller]=Search&tx_indexedsearch_pi2[search][sword]=${encoded}`;
      window.open(searchUrl, '_blank'); // Open in new tab
    }
  };

  // Handle Enter key press in search input
  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      redirectToAG();
    }
  };


  return (
    <Navbar className="sec-navbar" bg="light" expand="lg" expanded={expanded}>
      <Navbar.Brand className={` nav-brand-main`} as={Link} to="/">
        <img
          src={logo}
          className={`d-inline-block align-top logo-nav-main ${isSticky ? "logo-stuck" : "logo-not-stuck"}`}
          alt="Logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav navbar-toggle-hamburger" onClick={() => setExpanded(!expanded)}></Navbar.Toggle>
      <Navbar.Collapse id="basic-navbar-nav">
        <Nav className="mr-auto margin-l basic-navbar-main-menu">
          <div className="nav-wrapper">
            <NavDropdown title={t('HANSA-FLEX Serbia')} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/who-we-are">{t("Who we are")}</NavDropdown.Item>
              <NavDropdown title={t('Sectors and branches')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/branch-1">{t('HANSA-FLEX Beograd-Zemun')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-2">{t('HANSA-FLEX Kragujevac')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-3">{t('HANSA-FLEX Niš')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-4">{t('HANSA-FLEX Novi Sad')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-5">{t('HANSA-FLEX Železnik')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-6">{t('HANSA-FLEX Leštane')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-7">{t('HANSA-FLEX Valjevo')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-8">{t('HANSA-FLEX Užice')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-9">{t('HANSA-FLEX Subotica')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/branch-10">{t('HANSA-FLEX Cylinder Center')}</NavDropdown.Item>

              </NavDropdown>
              <NavDropdown.Item as={Link} to="/management">{t("Management")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/journey">{t("Journey")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/certificates">{t("Certificates")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/contact-us">{t("Contact us")}</NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/careers">Careers</NavDropdown.Item> */}
            </NavDropdown>
            <div className="nav-line"></div>
          </div>

          <div className="nav-wrapper">
            <NavDropdown title={t('HANSA-FLEX Group')} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/hf-group-management">{t('Management')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/annual-report">{t('Annual Report')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/hf-group-history">{t('History')}</NavDropdown.Item>
              {/* <Nav.Link href="https://www.hansa-flex.de/niederlassungssuche/" target="_blank" rel="noopener noreferrer" className='drop-menu-item-link' style={{ fontSize: '1rem', fontWeight: 350, paddingLeft: '-2px' }}>
                {('Branch Search')}
              </Nav.Link> */}
              <NavDropdown title={t('Responsibility and Social Commitments')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/responsibility-and-social-commitments">{t('Responsibility and Social Commitments')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/donation-instead-gifts">{t('Donations instead of gifts')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/diversity">{t('Diversity')}</NavDropdown.Item>
              </NavDropdown>
              <NavDropdown.Item as={Link} to="/hf-group-mission-statement">{t('Mission Statements and values')}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/certificates">{t("Certificates")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/associations">{t("Associations")}</NavDropdown.Item>
              {/* <NavDropdown.Item as={Link} to="/upcoming-events">{t("Measures")}</NavDropdown.Item> */}
              <NavDropdown.Item as={Link} to="/hf-60-years-of-hansaflex">{t('60 years of HANSA-FLEX')}</NavDropdown.Item>
              <Nav.Link href="https://www.hansa-flex.de/en/company/" target="_blank" rel="noopener noreferrer" className='drop-menu-item-link' style={{ fontSize: '1rem', fontWeight: 350, paddingLeft: '-2px' }}>
                {t('More About HANSA-FLEX Group')}
              </Nav.Link>
            </NavDropdown>
            <div className="nav-line"></div>
          </div>

          <div className="nav-wrapper">
            <NavDropdown title={t('Products')} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown title={t('Hoses and hose lines')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/hoses-and-hose-lines">{t('Hoses and hose lines')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hose-line-config">{t('Hose line configurator')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hydraulic-hoses">{t('Hydraulic hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/metal-hoses">{t('Metal hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Industrial-hoses">{t('Industrial hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/performed-hoses">{t('Preformed hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ext-high-pfm-hoses">{t('Extremely high-pressure hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Ptfe-hoses">{t('PTFE hoses')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hose-accessories">{t('Accessories')}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t('Pipelines')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/pipelines">{t('Pipelines')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pipebends">{t('Pipebends')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pipeend-processing">{t("Pipe-end processing")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Expansionjoints">{t("Expansion joints")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Drive and control technology")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/drive-and-control-tech">{t("Drive and control technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pumps">{t('Pumps')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hydraulic-motor">{t('Hydraulic motors')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/cylinder">{t('Cylinders')}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/switches-and-sensors">{t('Switches and sensors')}</NavDropdown.Item>
                <NavDropdown title={t("Valve technology")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/valve-tech">{t("Valve technology")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/pipeline-installation-valve">{t("Pipeline installation valves")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/cartridge-valve">{t("Cartridge valves")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/cetop-valve">{t("CETOP valves")}</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown.Item as={Link} to="/measuring-tech">{t("Measuring technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/seven-hundred-hydraulics">{t("700 bar heavy load hydraulics")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pressure-accumulators">{t("Pressure accumulators")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t('Hydraulic connection technology')} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/hydraulic-connection-technology">{t("Hydraulic connection technology")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hose-fitting">{t("Hose fittings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pipe-fitting">{t("Pipe fittings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/adapters">{t("Adapters")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/coupling">{t("Couplings")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/ball-valves">{t("Ball valves")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/flanges">{t("Flanges")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown.Item as={Link} to="/sealing-tech">{t("Sealing technology")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/filtration">{t("Filtration")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/pneumatics">{t("Pneumatics")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/technical-information">{t("Technical information")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/approvals">{t("Approvals")}</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/catalogues">{t("Catalogues")}</NavDropdown.Item>

            </NavDropdown>
            <div className="nav-line"></div>
          </div>


          <div className="nav-wrapper">
            <NavDropdown title={t("Services")} id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/mobile-rapid-hydraulic-service">{t("Mobile rapid hydraulic service")}</NavDropdown.Item>

              <NavDropdown title={t("Fluid management")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/fluid-service">{t("Fluid management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/oil-analysis">{t("Oil analysis")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/oil-filtering-and-cleaning">{t("Oil filtering and cleaning")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Assembly and installation")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/assembly-and-installation">{t("Assembly and installation")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/modernisation-and-optimisation">{t("Modernisation and optimisation")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/plant-project-planning-and-management">{t("Plant project planning and management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/installation-of-pipe-and-hoseline-systems">{t("Installation of pipe and hose line systems")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Preventative maintenance")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/preventative-maintainance">{t("Preventative maintenance")}</NavDropdown.Item>
                <NavDropdown title={t("Hose management")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/hose-management">{t("Hose management")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/x-code-hose-identification-system">{t("X-CODE hose identification system")}</NavDropdown.Item>
                  <NavDropdown title={t("X-CODE Manager")} id="nested-nav-dropdown" drop='start'>
                    <NavDropdown.Item as={Link} to="/x-code-manager">{t("X-CODE Manager")}</NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/licenses">{t("Licences")}</NavDropdown.Item>
                  </NavDropdown>
                  <NavDropdown.Item as={Link} to="/service-packages">{t("Service packages")}</NavDropdown.Item>
                </NavDropdown>
                <NavDropdown title={t("Inspections")} id="nested-nav-dropdown" drop='end'>
                  <NavDropdown.Item as={Link} to="/inspection">{t("Inspections")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/dguv-inspection">{t("DGUV inspection")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/industrial-hose-inspection">{t("Industrial hose inspection")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/lifting-platforms-and-loading-bridges">{t("Lifting platforms and loading bridges")}</NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/Pressureaccumulatorinspection">{t("Pressure accumulator inspection")}</NavDropdown.Item>
                </NavDropdown>
              </NavDropdown>

              <NavDropdown title={t("Repair and overhaul")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/repair-and-overhaul">{t("Repair and overhaul")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hydraulic-cyclinder-repair">{t("Hydraulic cylinder repair")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/pressure-accumulators-and-associated-systems">{t("Pressure accumulators and associated systems")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Digital services")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/DigitalServices">{t("Digital services")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Scannersolutions">{t("Scanner solutions")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/EDIandBMEcat">{t("EDI and BMEcat")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Production")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/Production">{t("Production")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/SeriesProduction">{t("Series production")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Customisedassembly">{t("Customised assembly")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Logistics solutions")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/Logisticssolutions">{t("Logistics solutions")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Warehousemanagement">{t("Warehouse management")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Kanbandelivery">{t("Kanban delivery")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Kitting">{t("Kitting")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Hydraulicworkshopcontainers">{t("Hydraulic workshop containers")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Worksinworks">{t("Works-in-works")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown title={t("Engineering")} id="nested-nav-dropdown" drop='end'>
                <NavDropdown.Item as={Link} to="/Engineering">{t("Engineering")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/EngineeredbyHansaflex">{t("Engineered by HANSA-FLEX")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Hydraulicunit">{t("Hydraulic unit manufacture")}</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/Prototypemanufacture">{t("Prototype manufacture")}</NavDropdown.Item>
              </NavDropdown>

              <NavDropdown.Item as={Link} to="/hydraulic-academy">{t("Training and seminars")}</NavDropdown.Item>
              <Nav.Link href="https://my.hansa-flex.rs/sr_RS/login" target="_blank" rel="noopener noreferrer" style={{ paddingLeft: '30px', fontSize: '1rem', fontWeight: 350 }}>
                {t("X-CODE Manager")}
              </Nav.Link>
            </NavDropdown>
            <div className="nav-line"></div>
          </div>

          <div className="nav-wrapper">
            <Nav.Link href="https://shop.hansa-flex.rs/sr_RS/" target="_blank" rel="noopener noreferrer">{t("Online Catalogue")} </Nav.Link>
            <div className="nav-line"></div>
          </div>

          <div className="nav-wrapper">
            <Nav.Link href="/contact-us">{t("Contact us")} </Nav.Link>
            <div className="nav-line"></div>
          </div>

          {/* <div className="nav-wrapper">
            <NavDropdown title="News and Events" id="basic-nav-dropdown" className="no-arrow" onSelect={handleDropdownClose}>
              <NavDropdown.Item as={Link} to="/iree">HANSA-FLEX at IREE </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/bauma">Bauma Conexpo India 2023 </NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/tree-plantation">Tree Plantation on Environment Day</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/product-training">Product training session</NavDropdown.Item>
              <NavDropdown.Item as={Link} to="/goethe-event">Goethe Event</NavDropdown.Item>

              {/*<NavDropdown.Item href="#action/3.2">Dropdown Item 2</NavDropdown.Item>
        <NavDropdown.Item href="#action/3.3">Dropdown Item 3</NavDropdown.Item>

            </NavDropdown>
            <div className="nav-line"></div> 
          </div>*/}


          {/* <div className="nav-wrapper">
            <NavLink as={Link} to="/careers">Careers</NavLink>
            <div className="nav-line"></div>
          </div> */}


          <hr />
          <div className="additional-nav-mobile-menu">
            <div className='d-flex align-items-center'>
              <FaLanguage />  <span className={`language-label ${!checked ? 'active' : ''}`} style={{ marginLeft: '15px' }}>{t("Serbia")} </span>
              <Switch
                checked={checked}
                onChange={handleChange}
                onSelect={handleDropdownClose}
                onColor="#4CAF50"
                offColor="#FF5722"
                onHandleColor="#fff"
                offHandleColor="#fff"
                handleDiameter={20}
                uncheckedIcon={false}
                checkedIcon={false}
                height={22}
                width={48}
                className="language-switch"
              />
              <span className={`language-label ${checked ? 'active' : ''}`}> {t("English")} </span>
            </div>
            <Nav.Link>
              <div className="search-container d-flex align-items-center">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onKeyPress={handleKeyPress}
                  placeholder="Search"
                  className="form-control"
                  style={{ width: '200px', padding: '2px', fontSize: '0.9rem', border: '2px solid #30557D', borderRadius: '4px' }}
                />
                <div onClick={redirectToAG} className="search-button m-2 d-flex align-items-center" type="button">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-search" viewBox="0 0 16 16">
                    <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
                  </svg>
                </div>
              </div>
            </Nav.Link>
            {/* <Nav.Link href="https://shop.hansa-flex.rs/sr_RS/" target="_blank" rel="noopener noreferrer" onSelect={handleDropdownClose}>
              <FaShoppingCart />  {t("Online-Catalogue")}

            </Nav.Link>
            <Nav.Link href="https://my.hansa-flex.rs/sr_RS/login" target="_blank" rel="noopener noreferrer" onSelect={handleDropdownClose}>
              <FaCode />  {t("X-CODE Manager")}
            </Nav.Link> */}
          </div>

        </Nav>
      </Navbar.Collapse>
    </Navbar >
  );
}

export default MainNavbarMenu;
